import React, { useState, useCallback } from "react";
import * as Scrivito from "scrivito";
import { Button, Form } from "reactstrap";
import { UserNameInput } from "components/AuthInputs/UserNameInput";
import { useTranslate } from "hooks";

type ResetViewProps = {
  page: Scrivito.Obj;
};

const ResetView = Scrivito.connect(({ page }: ResetViewProps) => {
  const translate = useTranslate();
  const [userEmail, setUserEmail] = useState("");

  const handleReset = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    // TODO: No endpoint from DS yet
  };

  const handleEmailChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setUserEmail(e.target.value);
    },
    [],
  );

  // TODO: temp vars - to remove when we receive the proper endpoint
  const resetPassErr = null;
  const isResetPassPending = false;

  return (
    <Form
      onSubmit={handleReset}
      className="bg-white col-md-6 mx-auto p-0 d-flex flex-column"
      data-testid="reset-view"
    >
      <div className="p-4 font-size-md">
        <Scrivito.LinkTag
          data-testid="ResetView_login-page-link"
          className="text-secondary"
          to={page}
          params={{ view: "login" }}
        >
          <span className="fal fa-angle-left"> </span>
          <div>{translate("RESET_VIEW_BACK_TO_LOGIN_BUTTON")}</div>
        </Scrivito.LinkTag>
      </div>
      <div className="col-md-11 mx-auto text-start">
        <h1>{translate("RESET_VIEW_RESET_HEADER")}</h1>
        <p>{translate("RESET_VIEW_RESET_DESCRIPTION")}</p>
        <UserNameInput
          type="email"
          value={userEmail}
          label={translate("LOGIN_VIEW_EMAIL_FIELD_LABEL")}
          error={resetPassErr}
          name="userEmailField"
          id="userEmailFieldId"
          testId="email"
          onChange={handleEmailChange}
          classNames="mb-0"
        />
        <div className="row m-0">
          {resetPassErr && (
            <div className="col-md-16 p-0 text-start text-danger">
              {`${translate("LOGIN_VIEW_ERROR_OCCURRED")}: ${resetPassErr}`}
            </div>
          )}
        </div>
        <div className="text-end mt-5 mb-6">
          <Button
            data-testid="ResetView_reset-pass-btn"
            type="submit"
            disabled={isResetPassPending}
            color="primary"
            className="ms-3 my-3"
          >
            {translate("RESET_VIEW_RESET_BUTTON")}
          </Button>
        </div>
      </div>
    </Form>
  );
});

export default ResetView;
